import { render, staticRenderFns } from "./sys.vue?vue&type=template&id=7c2df6f0&scoped=true&"
import script from "./sys.vue?vue&type=script&lang=js&"
export * from "./sys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2df6f0",
  null
  
)

export default component.exports